import React from 'react'
import Card from '../Card';
import i18n from 'i18n';
import styles from './MainApp.organisms.Dashboard.DeliveredOrdersCard.module.scss';

const DeliveredOrdersCard = ({items}) => {
    return <div className={styles["delivered-orders-card-container"]}>
        <Card>
            <div className={styles["title-container"]}>
                <h1 className={styles["dashboard-card-title"]}>{i18n.t("orders.delivered")}</h1>
            </div>

            <div className={styles["delivered-orders-table"]}>
                {items.map((item, i) => {
                    if( i <= 5) {
                        return <div key={item.client} className={styles["delivered-orders-item"]}>
                            <div className={i === 0 ? styles["delivered-orders-item-client-first"] : styles["delivered-orders-item-client"]}>{item.client}</div>
                            <div className={i === 0 ? styles["delivered-orders-item-orders-first"] : styles["delivered-orders-item-orders"]}>
                              {i === 0 && <span>{i18n.t("orders")[0].toUpperCase() + i18n.t("orders").substring(1)}</span>} {item.orders} {i !== 0 && i18n.t("orders")}
                            </div>
                        </div>
                    }
                })}
            </div>
        </Card>
    </div>
};

export default DeliveredOrdersCard;